const unifiedConsole = {
  roleLabel: {
    orgManager: "Yfirstjórnandi",
    manager: "Stjórnandi",
    researcher: "Rannsakandi",
  },
  loadError: "Ekki tókst að sækja stjórnborð",
  noData: "Engin stjórnborðsgögn tiltæk",
  welcomeBack: "Velkomin/n aftur",
  defaultUserName: "þangað",
  metrics: {
    project_one: "Verkefni",
    project_other: "Verkefni",
    dataRequests: "Gagnabeiðnir",
    availableDatasets: "Tiltæk gagnasöfn",
  },
  actions: {
    browseDatasets: "Skoða gagnasöfn",
    newDataRequest: "Ný gagnabeiðni",
    deidentifyFile: "Fjarlægja auðkenni úr skrá",
  },
  attention: {
    heading: "Krefst athygli þinnar",
    empty: "Ekkert að yfirfara eins og er.",
    requestedBy: "{{userName}} óskar eftir ",
    projectFallback: "Verkefni {{id}}",
    requestedOn: " · Óskað eftir {{date}}",
    review: "Yfirfara",
  },
  yourRequests: {
    heading: "Beiðnirnar þínar",
    viewAll: "Sjá allar",
    summary: "{{pending}} í bið · {{resolved}} afgreiddar",
  },
  yourProjects: {
    heading: "Verkefnin þín",
    emptyManager: "Engin verkefni ennþá. Búðu til eitt til að byrja.",
    emptyOther: "Hafðu samband við stjórnanda til að fá aðgang að rannsóknarverkefni.",
    owner: "Eigandi",
  },
  projectSelector: {
    title: "Veldu verkefni",
    prompt: "Veldu verkefni:",
  },
};

export default unifiedConsole;
